import type { Dispatch } from "react";
import type { EditorAction } from "../editor/reducers";
import type { CellRole, CellScope } from "./types";
import { mdiTableQuestion } from "@mdi/js";
import { useTranslation } from "react-i18next";
import { TableEditorStep } from "./TableEditorStep";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@acdc2/ui/components/select";

type Props = {
  dispatch: Dispatch<EditorAction>;
  soleCellRole: CellRole | undefined;
  soleCellScope: CellScope | undefined;
  isAnyCellSelected: boolean;
};

export function TableEditorStep5({
  dispatch,
  soleCellRole,
  soleCellScope,
  isAnyCellSelected,
}: Props) {
  const { t } = useTranslation();

  return (
    <TableEditorStep
      value="step5"
      iconPath={mdiTableQuestion}
      title={t("TableEditorStep5.title")}
      description={t("TableEditorStep5.description")}
    >
      <div className="flex flex-col gap-2">
        <Select
          disabled={!isAnyCellSelected}
          value={soleCellRole ?? ""}
          onValueChange={(newValue) => {
            if (!newValue) return;
            dispatch({
              type: "updateTableCellRoles",
              role: newValue as CellRole,
            });
          }}
        >
          <SelectTrigger className="w-full">
            <SelectValue
              placeholder={t("TableEditorStep5.inputs.role.placeholder")}
            />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="td">
              {t("TableEditorStep5.inputs.role.labels.td")}
            </SelectItem>
            <SelectItem value="th">
              {t("TableEditorStep5.inputs.role.labels.th")}
            </SelectItem>
          </SelectContent>
        </Select>

        <Select
          disabled={soleCellRole !== "th"}
          value={soleCellScope ?? ""}
          onValueChange={(newValue) => {
            if (!newValue) return;
            dispatch({
              type: "updateTableCellScopes",
              scope: newValue as CellScope,
            });
          }}
        >
          <SelectTrigger className="w-full">
            <SelectValue
              placeholder={t("TableEditorStep5.inputs.scope.placeholder")}
            />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="row">
              {t("TableEditorStep5.inputs.scope.labels.row")}
            </SelectItem>
            <SelectItem value="col">
              {t("TableEditorStep5.inputs.scope.labels.col")}
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
    </TableEditorStep>
  );
}
